import axios from '@/plugins/axios'

class ImportacaoService {
	axios: typeof axios
	route: string = '/importacoes'

	constructor() {
		this.axios = axios
	}

	async importar(entidade: 'eventos', formData: FormData): Promise<{ message: string }> {
		const { data } = await this.axios.post<{ message: string }>(`${this.route}/${entidade}`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		})
		return data
	}
}

export default new ImportacaoService()
